import { lazy } from 'react';

// Types
import { PartnerDiscountProps as LazyComponentProps } from './PartnerDiscount.types';

// Components
import withSuspense, { lazyRetry } from '@components/suspense';

const LazyComponent = lazy(() =>
  lazyRetry(() => import(/* webpackChunkName: "partnerDiscount" */ './PartnerDiscount')),
);

const LazyComponentWithSuspense = withSuspense<LazyComponentProps>(LazyComponent, 'PartnerDiscount');

// Exports
export default LazyComponentWithSuspense;
export { LazyComponent as PartnerDiscount };
